import styled from 'styled-components'

import { makeStyles } from '@material-ui/core/styles'

export const Centered = styled.div`
  display: flex;
  justify-content: center;
`

export const useStyles = makeStyles(() => ({
  tableActionButtonIcon: {
    width: '26px',
    height: '26px',
  },
}))
